import React, { createContext, useEffect } from 'react'
import { useQueryParams } from '@fs/zion-router'
import { usePlaylistContainerContext } from './PlaylistContainerProvider'
import { FLAGS } from '../config'
import { usePlaylists } from '../hooks/playlist/usePlaylists'
import { usePlaylistUpdate } from '../hooks/playlist/usePlaylistUpdate'
import { useFlagsContext } from './RootstechFlagsProvider'

const AutoAddToPlaylistContext = createContext<null>(null)

type AutoAddToPlaylistProviderProps = {
  children: React.ReactNode
}

export const AutoAddToPlaylistProvider = ({ children }: AutoAddToPlaylistProviderProps): JSX.Element => {
  const { query, removeQuery } = useQueryParams()
  const { [FLAGS.NEW_PLAYLIST_STATE]: newPlaylistStateFlag } = useFlagsContext()
  const oldContext = usePlaylistContainerContext()
  const { playlists = [] } = usePlaylists()
  const { updatePlaylist } = usePlaylistUpdate()

  useEffect(() => {
    if (query.addToPlaylist) {
      if (newPlaylistStateFlag.isOn) {
        const defaultPlaylistId = playlists.find((p) => p.default)?.id
        if (defaultPlaylistId) {
          updatePlaylist({ id: defaultPlaylistId, addItems: [query.addToPlaylist] }).catch(() => {
            // Error handling is already done in the mutation hook
          })
        }
      } else {
        oldContext.addToPlaylist({ playlistId: oldContext.defaultPlaylistId, items: [query.addToPlaylist] })
      }
      removeQuery('addToPlaylist', 'playlistItemType')
    }
  }, [query, removeQuery, oldContext, newPlaylistStateFlag.isOn, playlists, updatePlaylist])

  return <AutoAddToPlaylistContext.Provider value={null}>{children}</AutoAddToPlaylistContext.Provider>
}

export default AutoAddToPlaylistProvider
